import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const CoxCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  return (
    <TextButton
      variant={variant}
      // eslint-disable-next-line no-script-url
      href="javascript:void(0)"
      target="_self"
      className="cox-cta"
      data-testid="cox-accelerate"
      data-vin={vin}
    >
      {ctaDetails.coxCtaLabel}
    </TextButton>
  );
};

export default CoxCta;
